import * as Redux from 'redux';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, Middleware } from 'redux';
import { filterOutNil } from './utils/ramda';
import { createPersistedRootReducer } from './reducers/persist';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import { isDebugMode } from './utils/local-storage';
import { WindowExtended } from './types';
import { root } from './sagas';
const { persistStore } = require('redux-persist');

declare const window: WindowExtended;

export const createStore = (namespace: string) => {
  const browserLogger = createBrowserLogger();
  const sagaMiddleware = createSagaMiddleware();

  const middleware: Middleware[] = filterOutNil([sagaMiddleware, browserLogger]);

  const store = Redux.createStore(
    createPersistedRootReducer(namespace),
    composeWithDevTools(applyMiddleware(...middleware))
  );

  window.store = store;
  const persistor = persistStore(store);
  window.persistor = persistor;

  const rootTask = sagaMiddleware.run(root);
  rootTask.done.catch(err => {
    window.Raven.captureException(err);
    console.error(err.code, err.message);
    console.error(err.stack || err);
  });

  return { store, persistor };
};

export const createBrowserLogger = () => {
  const loggerMiddleware = createLogger();
  return isDebugMode() ? loggerMiddleware : null;
};
